<template>
    <v-container>
        <template v-if="device">
            <div class="flex-h" style="margin-bottom: 20px; margin-top: 10px">
                <div class="text-h3">Устройство {{ device.name ? `«${device.name}»` : 'без имени' }}</div>
                <v-spacer />
                <div>
                    <v-btn
                        v-if="canResetState && doesDeviceHasState(device)"
                        icon
                        style="margin-right: 12px;"
                        title="Сбросить состояние"
                        @click="resetState"
                    >
                        <v-icon>mdi-backup-restore</v-icon>
                    </v-btn>

                    <router-link v-if="canEdit" is="v-btn" :to="'/devices/edit/' + device.id">
                        <v-icon>mdi-pencil</v-icon>&nbsp;Редактировать
                    </router-link>
                </div>
            </div>

            <div class="flex-h" style="justify-content: space-between;">
                <div>
                    <b>Группа</b><br>
                    {{ device.group?.name || 'без группы' }}
                </div>
                <div>
                    <b>Состояние</b><br>
                    {{ device.stateLabel }}
                </div>
                <div>
                    <b>Тип</b><br>
                    {{ device.typeLabel }}
                </div>
                <div>
                    <b>Код устройства</b><br>
                    {{ device.code }}
                </div>
                <div>
                    <b>Последнее обновление</b><br>
                    {{ displayTime(lastUpdatedAt) || 'неизвестно' }}
                </div>
            </div>

            <PowerPacketsBlock v-if="isDeviceEmitter(device)" :device="device" />

            <DetectorPacketsBlock v-if="isDeviceDetector(device)" :device="device" />
        </template>
    </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import {Inject} from 'vue-property-decorator'
import Api from '@/services/Api'
import {Device, doesDeviceHasState, isDeviceDetector, isDeviceEmitter} from '@/models/Device'
import DeviceBrowser from '@/components/browsers/DeviceBrowser.vue'
import DeviceEditor from '@/components/modals/DeviceEditor.vue'
import {Chart} from 'highcharts-vue'
import DatePicker from 'vue2-datepicker'
import {displayTime} from '@/utils/datetime'
import PowerPacketsBlock from '@/views/view-device/PowerPacketsBlock.vue'
import DetectorPacketsBlock from '@/views/view-device/DetectorPacketsBlock.vue'

@Component({
    components: {DetectorPacketsBlock, PowerPacketsBlock, Chart, DeviceEditor, DeviceBrowser, DatePicker},
})
export default class ViewDeviceView extends Vue
{
    @Inject('api') private api!: Api

    deviceId: number | null = null
    device: Device | null = null

    isDeviceEmitter = isDeviceEmitter
    isDeviceDetector = isDeviceDetector

    doesDeviceHasState = doesDeviceHasState
    displayTime = displayTime

    get lastUpdatedAt(): string|undefined {
        if (!this.device) {
            return undefined
        }
        if (isDeviceEmitter(this.device)) {
            return this.device.lastPowerPacket?.receivedAt
        }
        if (isDeviceDetector(this.device)) {
            return this.device.lastDetectorPacket?.receivedAt
        }
        return undefined
    }

    async created() {
        this.deviceId = parseInt(this.$route.params.id)
        if (this.deviceId) {
            this.device = await this.fetchDevice()
        }
    }

    async fetchDevice() {
        if (this.deviceId) {
            return await this.api.getDevice(this.deviceId, ['typeLabel', 'stateLabel', 'group.name', 'lastPowerPacket', 'lastDetectorPacket'])
        }
        return null
    }

    get canEdit(): boolean {
        return ['admin'].includes(this.$store.state.user.role)
    }

    get canResetState(): boolean {
        return ['admin'].includes(this.$store.state.user.role)
    }

    async resetState() {
        if (this.deviceId != null && confirm('Вы уверены, что хотите сбросить состояние устройства?')) {
            await this.api.resetDeviceState(this.deviceId)
            this.device = await this.fetchDevice()
        }
    }
}
</script>
